import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { setCookie } from "../../Helpers/session";


export const loginSlice = createSlice({
	name: "login",
	initialState: {
		loginInfo: [],
		errors: [],
	},
   
	reducers: {
		getLoginInfo: (state, action) => {
			state.loginInfo = action.payload
			console.log(action.payload)
			
		},

		getLoginInfoSuccess: (state, action) => {
			console.log(action.payload)
			state.loginInfo = action.payload
			console.log(action.payload.data.data.refresh, "reducer")
			setCookie("refresh_token", action.payload.data.data.refresh)
			setCookie("access_token", action.payload.data.data.access)		
		},

		getErrors: (state, action) => {
			state.errors = action.payload.response.data

			console.log(state.errors, 'from reduce error');
			
			if(state.errors.detail){

				toast.error(`${state.errors.detail}`, {
					position: "top-right",
					autoClose: 2000,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
				})
			}
			// console.log(state.errors.detail, "reducer")
			}
		
	},
	

})


export const {getLoginInfo, getErrors, getLoginInfoSuccess} = loginSlice.actions

export default loginSlice.reducer
